import {useActiveRoute} from '../../../hooks/use-active-route'
import {useFeatureState} from '../../../hooks/use-feature-state'
import {FeatureState} from '../../../page-data/payloads/header'
import {OverviewFeedback} from './OverviewFeedback'
import {Button} from '@primer/react'
import {useToggleFeaturePreview} from '../../../hooks/use-toggle-feature-preview'
import {useLayoutRouteData} from '../../../page-data/loaders/use-layout-route-data'

export function OverviewFeatureToggle() {
  const {urls} = useLayoutRouteData()
  const overviewFeatureState = useFeatureState('overview')
  const activeRoute = useActiveRoute()
  const toggleFeature = useToggleFeaturePreview('prs_overview_react')

  const handleToggleOn = async () => {
    await toggleFeature()
    window.location.href = `${urls.overview}?overview=true`
  }

  if (overviewFeatureState === FeatureState.Enabled && activeRoute === 'overview') {
    return <OverviewFeedback />
  }

  if (overviewFeatureState === FeatureState.Available && activeRoute === 'conversation') {
    return (
      <Button onClick={handleToggleOn} variant="invisible" size="small" aria-label="Try the Overview page">
        <span aria-hidden="true">✨ </span>
        Try the Overview page
      </Button>
    )
  }

  return null
}
